<template>
  <div>
    <Title :pages="[{ icon: 'envelope', page: page_title.toUpperCase() }]"></Title>

    <v-container fluid>

      <v-card>
        <div class="row mb-2 mt-0">
          <div class="col-md-12" v-if="list_access">
            <div class="col-md-12" style="background:white; elevation-0">
              <div class="row pt-5">
                <div class="col-md-2">
                  <v-menu ref="desde_selected" v-model="desde_selected_open" :close-on-content-click="false"
                    :close-on-click="false" :return-value.sync="desde_selected" transition="scale-transition" offset-y
                    max-width="290px" min-width="auto" clearable>
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field v-model="desde_selected" label="Desde" prepend-icon="mdi-calendar" readonly
                        v-bind="attrs" v-on="on" class="pt-0 mt-0"></v-text-field>
                    </template>
                    <v-date-picker v-model="desde_selected" type="date" no-title scrollable>
                      <v-spacer></v-spacer>
                      <v-btn text color="primary" @click="desde_selected_open = false"> Cancel </v-btn>
                      <v-btn text color="primary" @click="$refs.desde_selected.save(desde_selected)"> OK </v-btn>
                    </v-date-picker>
                  </v-menu>
                </div>

                <div class="col-md-2">
                  <v-menu ref="hasta_selected" v-model="hasta_selected_open" :close-on-content-click="false"
                    :close-on-click="false" :return-value.sync="hasta_selected" transition="scale-transition" offset-y
                    max-width="290px" min-width="auto" clearable>
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field v-model="hasta_selected" label="Hasta" prepend-icon="mdi-calendar" readonly
                        v-bind="attrs" v-on="on" class="pt-0 mt-0"></v-text-field>
                    </template>
                    <v-date-picker v-model="hasta_selected" type="date" no-title scrollable>
                      <v-spacer></v-spacer>
                      <v-btn text color="primary" @click="hasta_selected = false"> Cancel </v-btn>
                      <v-btn text color="primary" @click="$refs.hasta_selected.save(hasta_selected)"> OK </v-btn>
                    </v-date-picker>
                  </v-menu>
                </div>

                <div class="col-md-5 pt-0">
                  <v-radio-group v-model="is_sent" row>
                    <v-radio label="Enviados" value="1"></v-radio>
                    <v-radio label="No enviados" value="0"></v-radio>
                    <v-radio label="Todos" :value="null"></v-radio>
                  </v-radio-group>
                </div>

                <div class="col-md-3" style="display: flex; justify-content: end">
                  <v-btn color="info" class="" @click="filter">Buscar</v-btn>
                </div>
              </div>
            </div>
          </div>
        </div>
      </v-card>

      <v-card v-if="list_access">
        <v-card-title>
          <span class="text-uppercase">{{ page_title }}</span>
          <v-spacer></v-spacer>
          <v-text-field v-model="search" append-icon="search" label="Buscar" single-line hide-details></v-text-field>
        </v-card-title>
        <v-data-table :headers="headers" :items="list" :search="search" :loading="loading" loading-text="Cargando..."
          :options="{
            descending: true,
            itemsPerPage: 15,
          }" @pagination="updatePagination" :footer-props="{
            itemsPerPageOptions: [5, 10, 15, 50, -1],
          }">
          <template v-slot:item="props">
            <tr>
              <td>{{ props.item.created_at }}</td>
              <td>{{ props.item.to }}</td>
              <td>{{ props.item.subject }}</td>
              <td>{{ props.item.message }}</td>
              <td>
                <div>
                  {{ props.item.type === 'voucher' ? props.item.object.voucher_number_label :
                    props.item.object.spent_number_label }}
                </div>
                <span class="text-caption">{{ props.item.type === 'voucher' ? props.item.object.receiver.name :
                  props.item.object.supplier.name }}</span>
              </td>
              <!-- <td>{{ props.item.date_send != null ? <span>"SI"</span> : "NO" }}</td> -->
              <td v-if="props.item.date_send != null">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <span v-on="on" v-bind="attrs" class="success--text font-weight-bold">SI</span>
                  </template>
                  <span>{{ props.item.date_send }}</span>
                </v-tooltip>
              </td>
              <td v-else>
                 <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <span v-on="on" v-bind="attrs" class="error--text font-weight-bold">NO</span>
                  </template>
                  <span>{{ props.item.last_error_at }} - {{ props.item.count_error }}</span>
                </v-tooltip>
              </td>
              <td>{{ props.item.message_error != null && props.item.date_send == null ? props.item.message_error : "-" }}</td>

            </tr>
          </template>
          <template v-slot:no-results>
            <v-alert :value="true" color="error" icon="warning">
              {{ "Busqueda sin resultados - " + search }}
            </v-alert>
          </template>
        </v-data-table>
      </v-card>

      <DialogDelete :dialog_delete="dialog_delete" @updateDialogDelete="updateDialogDelete"
        @deleteItemConfirm="deleteItemConfirm" />
    </v-container>
  </div>
</template>

<script>
import Constant from "@/constants/sections";
import { formatUtils } from "@/libs/utils/formatUtils";
import GenericMixin from "@/mixins/GenericMixin.vue";
import Title from "@/components/Title.vue";
import DialogDelete from "@/components/DialogDelete.vue";
import RolMixin from "@/mixins/RolMixin.vue";
import { sendEmailService } from "@/libs/ws/sendEmailService";

export default {
  components: { Title, DialogDelete },
  mixins: [GenericMixin, RolMixin],
  data() {
    return {
      formatUtils: formatUtils,
      parent: this,
      service: sendEmailService,
      page_title: "Email Logs",
      modal_title: "Email Logs",
      defaultItem: null,
      headers: [
        {
          text: "Fecha de creación",
          align: "left",
          sortable: true,
          value: "created_at",
        },
        {
          text: "Enviado a",
          align: "left",
          sortable: true,
          value: "to",
        },
        {
          text: "Asunto",
          align: "left",
          sortable: true,
          value: "subject",
        },

        {
          text: "Mensaje",
          align: "left",
          sortable: true,
          value: "message",
        },

        {
          text: "Comprobante",
          align: "left",
          sortable: true,
          value: "type",
        },
        {
          text: "Enviado",
          align: "left",
          sortable: true,
          value: "",
        },
        {
          text: "Error",
          align: "left",
          sortable: true,
          value: "error_message",
        },
        
      ],
      list: [],
      dialog_delete: false,
      desde_selected: new Date(new Date().getFullYear(), new Date().getMonth(), 1).toISOString().slice(0, 10),
      hasta_selected: new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0).toISOString().slice(0, 10),
      desde_selected_open: false,
      hasta_selected_open: false,
      is_sent: null
    };
  },
  mounted() {
    this.loadList(this.service);
  },
  methods: {
    filter() {
      this.loadList(this.service, this.getFilterParams());
    },
    getFilterParams() {
      let params = {
        from: this.desde_selected,
        to: this.hasta_selected,
        is_sent: this.is_sent === null ? null : this.is_sent === "1" ? true : false
      };
      return params;
    },
    deleteItemConfirm() {
      this.delete(this.service);
      this.dialog_delete = false;
      this.loadList(this.service);
    },
  },
};

// TODO agregar un boton de limpiar busqueda.
</script>
